import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  Input,
  SimpleChanges,
  Output,
  ElementRef,
  ViewChildren,
  QueryList,
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Form,
  FormGroupDirective,
  NgForm,
  AbstractControl,
} from '@angular/forms';
import { Validators } from '@angular/forms';
import { GlobalsService } from 'src/app/shared/services/globals';
import { TranslateService } from '@ngx-translate/core';
import { EventEmitter } from '@angular/core';
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationComponent } from 'src/app/shared/components/modal/configuration/configuration.component';
import { EventEmitterService } from '../../services/event-emitter.service';
import { Alert } from '../../models/alert.model';
import { ModalConfirmComponent } from 'src/app/shared/components/modal/confirm/modal-confirm.component';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterEvent,
} from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-problem-definition',
  templateUrl: './problem-definition.component.html',
  styleUrls: ['./problem-definition.component.scss'],
})
export class ProblemDefinitionComponent implements OnInit {
  datosFormulario: FormGroup;
  errorNombre: boolean = false;
  errorSituacion: boolean = false;
  errorObjetivo: boolean = false;
  errorMaxLength: string = '';
  errorMaxLength2: string = '';
  @Input() public data: any = [];
  @Input() public fromHistoric: boolean = false;
  @Input() public newPlan: boolean = false;
  @Output() public emitActionPlanData = new EventEmitter();
  @ViewChild('botonConfig', { static: true }) botonConfig: ElementRef;
  @ViewChild('nombre', { static: true }) inputNombre: ElementRef;
  @ViewChild('formDirective') private formDirective: NgForm;

  @ViewChildren('nombre') nombre: QueryList<ElementRef>;
  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
    private globals: GlobalsService,
    private modalService: NgbModal,
    private emit: EventEmitterService,
    private el: ElementRef,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.createForm();
  }
  ngAfterViewInit() {
    this.setFocus();
    this.nombre.changes.subscribe(() => {
      this.setFocus();
    });
  }
  setFocus() {
    if (this.nombre.length > 0) {
      this.nombre.first.nativeElement.focus();
    }
  }
  ngOnInit(): void {
    if (this.translate.currentLang == 'es') {
      this.errorMaxLength =
        'Este campo excede el número máximo de caracteres permitidos';
      this.errorMaxLength2 =
        'Existen campos que exceden el número máximo de caracteres permitidos';
    } else {
      this.errorMaxLength =
        'This field exceeds the maximum number of characters allowed';
      this.errorMaxLength2 =
        'Some fields exceed the maximum number of characters allowed';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.data.nombre) {
      setTimeout(() => {
        this.fillForm(this.data);
      }, 10);
    }

    if (this.newPlan) {
      this.inputNombre.nativeElement.focus();
    }
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    // this.emit.subsVar.unsubscribe();
  }

  /**
   * @name resetForm
   * @author Daniel Ramirez
   * @description se reinicia el formulario
   */
  resetForm(form: FormGroup = this.datosFormulario): void {
    form.reset();
    setTimeout(() => {
      this.createForm();
    }, 10);
  }
  /**
   * @name fillForm
   * @author Daniel Ramirez
   * @description se llena el formulario segun los datos del plan seleccionado
   */
  fillForm(data) {
    this.datosFormulario.patchValue({
      nombre: data.nombre,
      situacion_tratar: data.situacion_tratar,
      objetivo: data.objetivo,
      unidad_monetaria: data.unidad_monetaria,
      aviso: data.aviso,
      usuario_autor_id: data.autor_id,
      saved: false,
      edited: false,
      unidad: data.unidad,
    });
    this.emitActionPlanData.emit({
      from: 'problem_def',
      data: this.datosFormulario.value,
    });
    this.datosFormulario.updateValueAndValidity();
  }
  /**
   * @name createForm
   * @author Daniel Ramirez
   * @description creacion de un nuevo formulario
   */
  createForm() {
    this.datosFormulario = this.fb.group({
      nombre: [
        { value: '', disabled: this.fromHistoric },
        [Validators.required, Validators.maxLength(144)],
      ],
      situacion_tratar: [
        {
          value: '',
          disabled: this.fromHistoric,
        },
        [Validators.required, Validators.maxLength(72)],
      ],
      objetivo: [
        {
          value: '',
          disabled: this.fromHistoric,
        },
        Validators.required,
      ],
      unidad: [''],
      aviso: [0],
      unidad_monetaria: [''],
      usuario_autor_id: [''],
      saved: [false],
      edited: [false],
      configuration: [false],
    });
    this.emitActionPlanData.emit({
      from: 'problem_def',
      data: this.datosFormulario.value,
    });
  }
  /**
   * @name changes
   * @author Daniel Ramirez
   * @description se emiten los cambios en el formulario
   */
  changes() {
    this.datosFormulario.patchValue({ saved: false, edited: true });
    // console.log(this.datosFormulario.value);

    this.emitActionPlanData.emit({
      from: 'problem_def',
      data: this.datosFormulario.value,
    });
  }
  /**
   * @name inputEvent
   * @author Daniel Ramirez
   * @description se emiten los cambios en el formulario
   */
  inputEvent() {
    this.datosFormulario.patchValue({ saved: false, edited: true });
    // console.log(this.datosFormulario.value);

    this.emitActionPlanData.emit({
      from: 'problem_def',
      data: this.datosFormulario.value,
    });
  }
  /**
   * @name openConfiguration
   * @author Daniel Ramirez
   * @description se abre el modal de datos de configuracion del plan
   */
  openConfiguration() {
    const modalRef = this.modalService.open(ConfigurationComponent, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.data = this.datosFormulario.value;
    modalRef.componentInstance.from = this.fromHistoric;
    modalRef.componentInstance.clickClose.subscribe((resp: any) => {
      this.patchValues(resp);
    });
  }
  /**
   * @name patchValues
   * @author Daniel Ramirez
   * @description se agregan los datos de configuracion del plan
   */
  patchValues(data) {
    this.datosFormulario.patchValue({
      unidad: data.unidad,
      aviso: data.aviso,
      unidad_monetaria: data.unidad_monetaria,
      configuration: true,
      saved: false,
      edited: true,
    });
    this.emitActionPlanData.emit({
      from: 'problem_def',
      data: this.datosFormulario.value,
    });
  }
  /**
   * @name createPlan
   * @author Daniel Ramirez
   * @description si el formulario es valido se emiten los datos para guardar el plan de accion
   */
  createPlan(edited: boolean) {
    if (this.datosFormulario.valid) {
      this.datosFormulario.patchValue({
        saved: true,
        usuario_autor_id: this.globals.user.id,
      });
      if (edited) {
        
        this.emitActionPlanData.emit({
          from: 'problem_def',
          data: this.datosFormulario.value,
        });
      } else {
        const modalRef = this.modalService.open(ModalConfirmComponent, {
          ariaLabelledBy: 'modal-basic-title',
          centered: true,
        });

        modalRef.componentInstance.title = 'save';
        modalRef.componentInstance.from = 'save';
        modalRef.componentInstance.clickClose.subscribe((resp: any) => {
          this.emitActionPlanData.emit({
            from: 'problem_def',
            data: this.datosFormulario.value,
          });
        });
      }
    } else {
      if (
        this.datosFormulario.get('nombre').hasError('maxlength') ||
        this.datosFormulario.get('situacion_tratar').hasError('maxlength')
      ) {
        Alert.buildErrorAlert(this.errorMaxLength2);
      } else {
        this.alert();
      }
    }
    // if (
    //   (this.datosFormulario.valid &&
    //     !this.datosFormulario.get('unidad').value) ||
    //   this.datosFormulario.get('aviso').value < 0
    // ) {
    //   this.alert_config();
    // }
    // if (!this.datosFormulario.valid) {
    // if (
    //   this.datosFormulario.get('nombre').hasError('maxlength') ||
    //   this.datosFormulario.get('situacion_tratar').hasError('maxlength')
    // ) {
    //   Alert.buildErrorAlert(this.errorMaxLength2);
    // } else {
    //   this.alert();
    // }
    // }
  }

  alert() {
    Alert.buildErrorAlert(
      this.translate.instant('action_plan.modal_save.error_empty')
    );

    this.validateAllFormFields(this.datosFormulario);
  }
  alert_config() {
    setTimeout((x) => this.botonConfig.nativeElement.focus());

    let formus = [];
    if (this.datosFormulario.get('aviso').value < 0) {
      formus.push(
        this.translate.instant('action_plan.problem_definition.modal.notice')
      );
    }
    if (!this.datosFormulario.get('unidad').value) {
      formus.push(
        this.translate.instant('action_plan.problem_definition.modal.unit')
      );
    }
    // if (!this.datosFormulario.get('unidad_monetaria').value) {
    //   formus.push(
    //     this.translate.instant(
    //       'action_plan.problem_definition.modal.monetary_unit'
    //     )
    //   );
    // }

    Alert.buildErrorAlert(
      this.translate.instant('action_plan.modal_save.error_configuration', {
        data: formus.join(', '),
      })
    );
  }
  /**
   * @name validateAllFormFields
   * @author Daniel Ramirez
   * @description recorre el formulario en busca de campos requeridos vacios y manda la informacion
   * para la alerta
   */
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        setTimeout((x) => control.markAsTouched({ onlySelf: true }));
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
    for (const key of Object.keys(this.datosFormulario.controls)) {
      if (this.datosFormulario.controls[key].invalid) {
        this.datosFormulario.controls[key].markAsTouched();
        const invalidControl = this.el.nativeElement.querySelector(
          '[formcontrolname="' + key + '"]'
        );
        setTimeout((x) => invalidControl.focus());

        break;
      }
    }
  }
}
